<template>
	<div v-if="userPwd.isPwdShow">
	    <!-- 重置子账号密码弹窗 -->
	    <div class="mask re-password user-center-modal">
	        <div class="e-modal small">
	            <div class="e-modal-title">重置子账号密码 <i class="e-modal-close" @click="userPwd.isPwdShow=false"></i></div>
	            <div class="e-modal-body">
	                <div class="e-form">
	                    <div class="form-contorl">
	                        <label class="title">新密码：</label>
	                        <input type="password" v-model="Pwd" />
	                    </div>
	                    <div class="form-contorl">
	                        <label class="title">确认密码：</label>
	                        <input type="password" v-model="Pwd2" />
	                    </div>
	                </div>
	            </div>
	            <div class="e-modal-footer">
	                <div class="long-btn save-btn" @click="save">保存</div>
	                <div class="long-btn cancel-btn" @click="userPwd.isPwdShow=false">取消</div>
	            </div>
	        </div>
	    </div>
	</div>
</template>
<script>
	export default{
		name:'resetPassword',
		props:{
			userPwd:{
				type:Object,
				default:function(){
					return{}
				}
			}
		},
		data(){
			return{
				Pwd:'',
				Pwd2:''
			}
		},
		methods:{
			save(){
				var that=this;
				var Pwd=that.Pwd;
				var Pwd2=that.Pwd2;
				if(!Pwd){
		            that.error({title: '创建错误',content: '请输入新密码'})
            		return;
				}
				if(Pwd.length<6||Pwd.length>32){
		            that.error({title: '创建错误',content: '账号密码长度最小6位, 最大 32 位'})
            		return;
				}

				if(!Pwd2){
		            that.error({title: '创建错误',content: '请输入确认密码'})
            		return;
				}

				if(Pwd!=Pwd2){
		            that.error({title: '创建错误',content: '两次密码输入不同'})
            		return;
				}

				var params={
					NO:this.userPwd.NO,
					IsActive:null,
					Pwd:Pwd==Pwd2?Pwd:'',
					Permissions:'',
					Hotels:null
				}
				
			
	            that.patchRequest({
	                url: that.Api.eidtSubUser,
	                params:params
	            }).then(res => {
	                if (res&&res.IsSuccess) {
	                    that.error({ title: '提示', content: '更新成功' });
	                	that.userPwd.isPwdShow=false;
	                	that.$emit('done')
	                } else {
	                    that.error({ title: '提示', content: '更新出错，请重试' });
	                }
	            });
			}
		}

	}
</script>


// WEBPACK FOOTER //
// src/components/user/ResetPassword.vue